var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSparkle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 19.8,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 21.6 19.8",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_3a)",
    d: "m4.6132 17.1296-1.414-.5288-.5288-1.414a.288.288 0 0 0-.27-.1875.288.288 0 0 0-.27.1875l-.529 1.414-1.4139.5288a.2882.2882 0 0 0 0 .5401l1.414.5288.5288 1.4139a.288.288 0 0 0 .27.1876.288.288 0 0 0 .27-.1876l.529-1.4139 1.4139-.5288a.2882.2882 0 0 0 0-.5401"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_4b)",
    d: "M19.8 9.9c0-.45-.2812-.8532-.7031-1.0125L13.8 6.9l-1.9875-5.297C11.6531 1.1813 11.25.9 10.8.9s-.8531.2812-1.0125.703L7.8 6.9 2.5031 8.8875C2.0812 9.0468 1.8 9.45 1.8 9.9s.2812.8531.7031 1.0125L7.8 12.9l1.9875 5.2968c.1594.4219.5625.7032 1.0125.7032s.8531-.2813 1.0125-.7032L13.8 12.9l5.2969-1.9875c.4219-.1594.7031-.5625.7031-1.0125"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_5c)",
    d: "M21.6 3.6005a.434.434 0 0 0-.2813-.405l-2.1191-.7951-.7951-2.1191A.434.434 0 0 0 17.9995 0a.434.434 0 0 0-.4051.2813l-.7951 2.119-2.1191.7952a.434.434 0 0 0-.2813.405c0 .18.1126.3413.2813.405l2.1191.7952.7951 2.119a.434.434 0 0 0 .4051.2814.434.434 0 0 0 .405-.2813l.7951-2.1191 2.1191-.7951a.434.434 0 0 0 .2813-.405"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_3a",
    x1: 1.4618,
    x2: 27.1232,
    y1: -1.7724,
    y2: 19.8022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_4b",
    x1: 1.4618,
    x2: 27.1232,
    y1: -1.7724,
    y2: 19.8022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_5c",
    x1: 1.4618,
    x2: 27.1232,
    y1: -1.7724,
    y2: 19.8022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSparkle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sparkle.4a26b633c6c96ad5b6be96824f96811f.svg";